import { IllustrationName } from './illustrationLibrary';

type OldIllustrationName =
  | 'notation'
  | 'expertise'
  | 'benefits_automation'
  | 'models'
  | 'autonomie'
  | 'purple_clock'
  | 'proximite'
  | 'control'
  | 'reactivite'
  | 'people_headphone';

export type AllIllustrationName = IllustrationName | OldIllustrationName;

export function retrocompatibility(name: AllIllustrationName): string {
  if (['notation', 'expertise'].includes(name)) {
    return 'golden_ribbon';
  }
  if (['benefits_automation', 'models'].includes(name)) {
    return 'models_blue';
  }
  if (['autonomie'].includes(name)) {
    return 'models_yellow';
  }
  if (['purple_clock'].includes(name)) {
    return 'timetracking_purple';
  }
  if (['proximite'].includes(name)) {
    return 'guides';
  }
  if (['reactivite'].includes(name)) {
    return 'people_headphone_man';
  }
  if (['people_headphone'].includes(name)) {
    return 'people_headphone_woman';
  }
  if (['control'].includes(name)) {
    return 'calculators';
  }

  return name;
}
